(function () {
  var summaryMoved = false;
  var listMoved = false;
  var sourceSection = null;
  var interval;

  function move() {
    var target = document.getElementById('klaviyo-reviews-accordion-target');
    if (!target) return;

    if (!summaryMoved) {
      var summary = document.querySelector('[id*="klaviyo_reviews_product_reviews_summary"]');
      if (summary) {
        if (!sourceSection) sourceSection = summary.closest('[id^="shopify-section-"]');
        target.appendChild(summary);
        summaryMoved = true;
      }
    }

    if (!listMoved) {
      var list = document.querySelector('[id*="klaviyo_reviews_product_reviews_list"]');
      if (list) {
        if (!sourceSection) sourceSection = list.closest('[id^="shopify-section-"]');
        target.appendChild(list);
        listMoved = true;
      }
    }

    if (summaryMoved && listMoved) {
      document.body.classList.add('klaviyo-reviews-moved');
      if (sourceSection) sourceSection.style.display = 'none';
      clearInterval(interval);
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 300);
    }
  }

  interval = setInterval(move, 500);
  // stop retrying after 15s
  setTimeout(function () { clearInterval(interval); }, 15000);
})();


// Saat accordion Reviews dibuka → trigger Klaviyo supaya render
document.addEventListener('toggle', function (e) {
  if (e.target.tagName === 'DETAILS' && e.target.open) {
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
      window.scrollBy(0, 1);
    }, 300);
  }
}, true);
